<template>
  <div>
    <!-- <p>{{appointment}}</p> -->

    <h3 class="title">AP印刷 : {{user.user}} ｜ 訪問日 : {{appointment.visit_date}} / {{appointment.visit_time}}</h3>
    <h3 class="title">希望曜日 : {{appointment.request_of_day_of_week}} / <span>{{appointment.request_of_day_of_week_note}}</span></h3>
    <div class="wrapper">
      <div class="table">
        <div class="tr">
          <div class="th">媒体</div>
          <div class="td">
            <template v-if="appointment.medium1 === 1">DM</template>
            <template v-if="appointment.medium1 === 2">貼紙</template>
            <template v-if="appointment.medium1 === 3">HP</template>
            <template v-if="appointment.medium1 === 4">紹介</template>
            <template v-if="appointment.medium1 === 5">TEL注</template>
            <template v-if="appointment.medium1 === 6">TA</template>
            <template v-if="appointment.medium1 === 7">その他</template>

            <template v-if="appointment.medium2 === 1">DM</template>
            <template v-if="appointment.medium2 === 2">貼紙</template>
            <template v-if="appointment.medium2 === 3">HP</template>
            <template v-if="appointment.medium2 === 4">紹介</template>
            <template v-if="appointment.medium2 === 5">TEL注</template>
            <template v-if="appointment.medium2 === 6">TA</template>
            <template v-if="appointment.medium2 === 7">その他</template>

            <template v-if="appointment.medium3 === 1">DM</template>
            <template v-if="appointment.medium3 === 2">貼紙</template>
            <template v-if="appointment.medium3 === 3">HP</template>
            <template v-if="appointment.medium3 === 4">紹介</template>
            <template v-if="appointment.medium3 === 5">TEL注</template>
            <template v-if="appointment.medium3 === 6">TA</template>
            <template v-if="appointment.medium3 === 7">その他</template>
          </div>
        </div>
        <div class="tr">
          <div class="th">AP種類</div>
          <div class="td">
            <template v-if="appointment.ap_type === 0">未選択</template>
            <template v-if="appointment.ap_type === 1">体験希望</template>
            <template v-if="appointment.ap_type === 2">資料請求</template>
            <template v-if="appointment.ap_type === 3">問い合わせ</template>
          </div>
        </div>
        <div class="tr">
          <div class="th">HP種類</div>
          <div class="td">
            <template v-if="appointment.hp_type === 0">未選択</template>
            <template v-if="appointment.hp_type === 1">自社</template>
            <template v-if="appointment.hp_type === 2">リスティング</template>
          </div>
        </div>
        <div class="tr">
          <div class="th">訪問日時</div>
          <div class="td">{{appointment.visit_date}} / {{appointment.visit_time}}</div>
        </div>
        <div class="tr">
          <div class="th">AP応対者 / 相手</div>
          <div class="td">
            <span>{{appointment.person}}</span>
            <span> / </span>
            <span v-if="appointment.contact_person === 0">未選択</span>
            <span v-if="appointment.contact_person === 1">母</span>
            <span v-if="appointment.contact_person === 2">父</span>
            <span v-if="appointment.contact_person === 3">祖母</span>
            <span v-if="appointment.contact_person === 4">祖父</span>
            <span v-if="appointment.contact_person === 5">本人</span>
            <span v-if="appointment.contact_person === 6">伯母</span>
            <span v-if="appointment.contact_person === 7">伯父</span>
          </div>
        </div>
        <div class="tr">
          <div class="th">名前</div>
          <div class="td">{{appointment.f_name}} {{appointment.l_name}}</div>
        </div>
        <div class="tr">
          <div class="th">かな</div>
          <div class="td">{{appointment.f_name_kana}} {{appointment.l_name_kana}}</div>
        </div>
        <div class="tr">
          <div class="th">住所</div>
          <div class="td">
            {{appointment.zip}}<br>
            <template v-if="appointment.pref === 0">未選択</template>
            <template v-if="appointment.pref === 1">北海道</template>
            <template v-if="appointment.pref === 2">青森県</template>
            <template v-if="appointment.pref === 3">秋田県</template>
            <template v-if="appointment.pref === 4">岩手県</template>
            <template v-if="appointment.pref === 5">山形県</template>
            <template v-if="appointment.pref === 6">宮城県</template>
            <template v-if="appointment.pref === 7">福島県</template>
            <template v-if="appointment.pref === 8">栃木県</template>
            <template v-if="appointment.pref === 9">山梨県</template>
            <template v-if="appointment.pref === 10">群馬県</template>
            <template v-if="appointment.pref === 11">茨城県</template>
            <template v-if="appointment.pref === 12">千葉県</template>
            <template v-if="appointment.pref === 13">埼玉県</template>
            <template v-if="appointment.pref === 14">東京都</template>
            <template v-if="appointment.pref === 15">神奈川県</template>
            <template v-if="appointment.pref === 16">静岡県</template>
            <template v-if="appointment.pref === 17">長野県</template>
            <template v-if="appointment.pref === 18">愛知県</template>
            <template v-if="appointment.pref === 19">岐阜県</template>
            <template v-if="appointment.pref === 20">新潟県</template>
            <template v-if="appointment.pref === 21">富山県</template>
            <template v-if="appointment.pref === 22">石川県</template>
            <template v-if="appointment.pref === 23">福井県</template>
            <template v-if="appointment.pref === 24">滋賀県</template>
            <template v-if="appointment.pref === 25">京都府</template>
            <template v-if="appointment.pref === 26">三重県</template>
            <template v-if="appointment.pref === 27">和歌山県</template>
            <template v-if="appointment.pref === 28">奈良県</template>
            <template v-if="appointment.pref === 29">大阪府</template>
            <template v-if="appointment.pref === 30">兵庫県</template>
            <template v-if="appointment.pref === 31">鳥取県</template>
            <template v-if="appointment.pref === 32">島根県</template>
            <template v-if="appointment.pref === 33">岡山県</template>
            <template v-if="appointment.pref === 34">広島県</template>
            <template v-if="appointment.pref === 35">山口県</template>
            <template v-if="appointment.pref === 36">高知県</template>
            <template v-if="appointment.pref === 37">徳島県</template>
            <template v-if="appointment.pref === 38">香川県</template>
            <template v-if="appointment.pref === 39">愛媛県</template>
            <template v-if="appointment.pref === 40">福岡県</template>
            <template v-if="appointment.pref === 41">佐賀県</template>
            <template v-if="appointment.pref === 42">長崎県</template>
            <template v-if="appointment.pref === 43">熊本県</template>
            <template v-if="appointment.pref === 44">宮崎県</template>
            <template v-if="appointment.pref === 45">大分県</template>
            <template v-if="appointment.pref === 46">鹿児島県</template>
            <template v-if="appointment.pref === 47">沖縄県</template>
            {{appointment.address1}} {{appointment.address2}}
          </div>
        </div>
        <div class="tr">
          <div class="th">TEL1</div>
          <div class="td">{{appointment.tel1}}</div>
        </div>
        <div class="tr">
          <div class="th">TEL2</div>
          <div class="td">{{appointment.tel2}}</div>
        </div>
        <div class="tr">
          <div class="th">前日確認TEL連絡先</div>
          <div class="td">
            <span v-if="appointment.preferred_contact === 0">未選択</span>
            <span v-if="appointment.preferred_contact === 1">自宅</span>
            <span v-if="appointment.preferred_contact === 2">携帯</span>
            <span v-if="appointment.preferred_contact === 3">勤務先</span>
            <span v-if="appointment.preferred_contact === 4">その他</span>
          </div>
        </div>
        <div class="tr">
          <div class="th">時間帯</div>
          <div class="td">{{appointment.contact_timezone}}</div>
        </div>
        <div class="tr">
          <div class="th">学校名 / 学年 / 性別</div>
          <div class="td">
            <span v-if="appointment.school_type === 0">未選択</span>
            <span v-if="appointment.school_type === 1">公立</span>
            <span v-if="appointment.school_type === 2">国立</span>
            <span v-if="appointment.school_type === 3">私立</span>
            <span v-if="appointment.school_type === 4">その他</span>
            <span> / </span>
            <span>{{appointment.school_name}}</span>
            <span> / </span>
            <span v-if="appointment.school_stage === 0">未選択</span>
            <span v-if="appointment.school_stage === 1">小学</span>
            <span v-if="appointment.school_stage === 2">中学</span>
            <span v-if="appointment.school_stage === 3">高校</span>
            <span v-if="appointment.school_stage === 4">幼稚園</span>
            <span v-if="appointment.school_stage === 5">その他</span>

            <span v-if="appointment.grade === 0">未選択</span>
            <span v-if="appointment.grade === 1">1</span>
            <span v-if="appointment.grade === 2">2</span>
            <span v-if="appointment.grade === 3">3</span>
            <span v-if="appointment.grade === 4">4</span>
            <span v-if="appointment.grade === 5">5</span>
            <span v-if="appointment.grade === 6">6</span>
            <span> / </span>
            <span v-if="appointment.gender === 0">未選択</span>
            <span v-if="appointment.gender === 1">男</span>
            <span v-if="appointment.gender === 2">女</span>
          </div>
        </div>
        <div class="tr">
          <div class="th">サブ名前</div>
          <div class="td">{{appointment.sub_f_name}} {{appointment.sub_l_name}}</div>
        </div>
        <div class="tr">
          <div class="th">サブかな</div>
          <div class="td">{{appointment.sub_f_name_kana}} {{appointment.sub_l_name_kana}}</div>
        </div>
        <div class="tr">
          <div class="th">サブ 学校名 / 学年 / 性別</div>
          <div class="td">
            <span v-if="appointment.sub_school_type === 0">未選択</span>
            <span v-if="appointment.sub_school_type === 1">公立</span>
            <span v-if="appointment.sub_school_type === 2">国立</span>
            <span v-if="appointment.sub_school_type === 3">私立</span>
            <span v-if="appointment.sub_school_type === 4">その他</span>
            <span> / </span>
            <span>{{appointment.sub_school_name}}</span>
            <span> / </span>
            <span v-if="appointment.sub_school_stage === 0">未選択</span>
            <span v-if="appointment.sub_school_stage === 1">小学</span>
            <span v-if="appointment.sub_school_stage === 2">中学</span>
            <span v-if="appointment.sub_school_stage === 3">高校</span>
            <span v-if="appointment.sub_school_stage === 4">幼稚園</span>
            <span v-if="appointment.sub_school_stage === 5">その他</span>

            <span v-if="appointment.sub_grade === 0">未選択</span>
            <span v-if="appointment.sub_grade === 1">1</span>
            <span v-if="appointment.sub_grade === 2">2</span>
            <span v-if="appointment.sub_grade === 3">3</span>
            <span v-if="appointment.sub_grade === 4">4</span>
            <span v-if="appointment.sub_grade === 5">5</span>
            <span v-if="appointment.sub_grade === 6">6</span>
            <span> / </span>
            <span v-if="appointment.sub_gender === 0">未選択</span>
            <span v-if="appointment.sub_gender === 1">男</span>
            <span v-if="appointment.sub_gender === 2">女</span>
          </div>
        </div>
      </div>

      <div class="table">
        <div class="tr">
          <div class="th">駐車場</div>
          <div class="td" v-if="appointment.parking === 0">未選択</div>
          <div class="td" v-if="appointment.parking === 1">有</div>
          <div class="td" v-if="appointment.parking === 2">無</div>
        </div>
        <div class="tr">
          <div class="th">駐車場備考</div>
          <div class="td">{{appointment.parking_note}}</div>
        </div>
        <div class="tr">
          <div class="th">メイン成績</div>
          <div class="td">{{appointment.achievement}}</div>
        </div>
        <div class="tr">
          <div class="th">メイン習い事</div>
          <div class="td">{{appointment.learning}}</div>
        </div>
        <div class="tr">
          <div class="th">メイン / いつから</div>
          <div class="td">{{appointment.learning_start_period}}</div>
        </div>
        <div class="tr">
          <div class="th">メイン / きっかけ</div>
          <div class="td">{{appointment.learning_nervous}}</div>
        </div>
        <div class="tr">
          <div class="th">メイン / 成果 / 継続</div>
          <div class="td">
            <span class="td" v-if="appointment.learning_result === 0">未選択</span>
            <span class="td" v-if="appointment.learning_result === 1">上がった</span>
            <span class="td" v-if="appointment.learning_result === 2">下がった</span>
            <span class="td" v-if="appointment.learning_result === 3">変わらない</span>
            <span class="td" v-if="appointment.learning_result === 4">わからない</span>
            <span> / </span>
            <span class="td" v-if="appointment.learning_continuation === 0">未選択</span>
            <span class="td" v-if="appointment.learning_continuation === 1">継続する</span>
            <span class="td" v-if="appointment.learning_continuation === 2">継続しない</span>
            <span class="td" v-if="appointment.learning_continuation === 3">わからない</span>
          </div>
        </div>
        <div class="tr">
          <div class="th">サブ成績</div>
          <div class="td">{{appointment.sub_achievement}}</div>
        </div>
        <div class="tr">
          <div class="th">サブ習い事</div>
          <div class="td">{{appointment.sub_learning}}</div>
        </div>
        <div class="tr">
          <div class="th">サブ / いつから</div>
          <div class="td">{{appointment.sub_learning_start_period}}</div>
        </div>
        <div class="tr">
          <div class="th">サブ / きっかけ</div>
          <div class="td">{{appointment.sub_learning_nervous}}</div>
        </div>
        <div class="tr">
          <div class="th">サブ / 成果 / 継続</div>
          <div class="td">
            <span class="td" v-if="appointment.sub_learning_result === 0">未選択</span>
            <span class="td" v-if="appointment.sub_learning_result === 1">上がった</span>
            <span class="td" v-if="appointment.sub_learning_result === 2">下がった</span>
            <span class="td" v-if="appointment.sub_learning_result === 3">変わらない</span>
            <span class="td" v-if="appointment.sub_learning_result === 4">わからない</span>
            <span> / </span>
            <span class="td" v-if="appointment.sub_learning_continuation === 0">未選択</span>
            <span class="td" v-if="appointment.sub_learning_continuation === 1">継続する</span>
            <span class="td" v-if="appointment.sub_learning_continuation === 2">継続しない</span>
            <span class="td" v-if="appointment.sub_learning_continuation === 3">わからない</span>
          </div>
        </div>
        <div class="tr">
          <div class="th">同席者 / 父親の絡み</div>
          <div class="td">
            <span>{{appointment.attended}}</span>
            <span> / </span>
            <span v-if="appointment.fathers_involvement === 0">未選択</span>
            <span v-if="appointment.fathers_involvement === 1">有</span>
            <span v-if="appointment.fathers_involvement === 2">無</span>
          </div>
        </div>
        <div class="tr">
          <div class="th">特記事項</div>
          <div class="td">{{appointment.notices}}</div>
        </div>
        <div class="tr">
          <div class="th">送るもの</div>
          <div class="td">{{appointment.sending_products}}</div>
        </div>
        <div class="tr">
          <div class="th">送る方法</div>
          <div class="td" v-if="appointment.sending_method === 0">未選択</div>
          <div class="td" v-if="appointment.sending_method === 1">郵送</div>
          <div class="td" v-if="appointment.sending_method === 2">FAX</div>
          <div class="td" v-if="appointment.sending_method === 3">MAIL</div>
          <div class="td" v-if="appointment.sending_method === 4">持っていく</div>
        </div>
        <div class="tr">
          <div class="th">郵送・FAX / 予定日</div>
          <div class="td">{{appointment.sending_date}}</div>
        </div>
        <div class="tr">
          <div class="th">送信時間</div>
          <div class="td">{{appointment.sending_time}}</div>
        </div>
      </div>

    </div>

    <div class="note">
      <div class="tr">
        <div class="th">必ず確認してメモを取ってもらう事</div>
        <div class="td">

          <template v-if="user.office_id === 2">
            <span v-if="appointment.transmission_item_company === 0">×</span><span v-if="appointment.transmission_item_company === 1">○</span> 会社の正式名称は伝えたか？（株式会社エイト）
          </template>
          <template v-else-if="user.office_id === 3">
            <span v-if="appointment.transmission_item_company === 0">×</span><span v-if="appointment.transmission_item_company === 1">○</span> 会社の正式名称は伝えたか？（株式会社よんろく）
          </template>
          <template v-else>
            <span v-if="appointment.transmission_item_company === 0">×</span><span v-if="appointment.transmission_item_company === 1">○</span> 会社の正式名称は伝えたか？（株式会社マスターマインズ）
          </template>

        </div>
        <div class="td">
          <span v-if="appointment.transmission_item_course === 0">×</span><span v-if="appointment.transmission_item_course === 1">○</span> 【家庭教師だけの指導】と【テキストを使う指導】の2通りある事を伝えたか？
        </div>
        <div class="td">
          <span v-if="appointment.transmission_item_visitor === 0">×</span><span v-if="appointment.transmission_item_visitor === 1">○</span> 体験学習には実際の先生ではなくADが行くことは伝えたか？
        </div>
        <div class="td">
          <span v-if="appointment.transmission_item_purpose === 0">×</span><span v-if="appointment.transmission_item_purpose === 1">○</span> 家庭教師及びテキスト販売契約について勧誘する目的は伝えたか？
        </div>
        <div class="td">
          <span v-if="appointment.transmission_item_requiredtime === 0">×</span><span v-if="appointment.transmission_item_requiredtime === 1">○</span> 体験は2時間であることは伝えたか？
        </div>
      </div>
    </div>

    <div class="note">
      <div class="tr">
        <div class="th">備考</div>
        <div class="td" style="white-space: pre-wrap">{{appointment.note}}</div>
      </div>
    </div>

    <div class="wrapper">
      <div class="table">
        <div class="tr">
          <div class="th">最寄駅</div>
          <div class="td" style="padding: 0"><input type="text" style="width: 100%; outline: 0"></div>
        </div>
        <div class="tr">
          <div class="th">徒歩移動時間</div>
          <div class="td" style="padding: 0"><input type="text" style="width: 100%; outline: 0"></div>
        </div>
        <div class="tr">
          <div class="th">年代</div>
          <div class="td">学生・社会人</div>
        </div>
      </div>

      <div class="table">
        <div class="tr">
          <div class="th">終電</div>
          <div class="td" style="padding: 0"><input type="text" style="width: 100%; outline: 0"></div>
        </div>
        <div class="tr">
          <div class="th">泊まり ○ or ×</div>
          <div class="td" style="padding: 0"><input type="text" style="width: 100%; outline: 0"></div>
        </div>
        <div class="tr">
          <div class="th">送迎</div>
          <div class="td">必要・不要</div>
        </div>
      </div>

    </div>

    <div class="note">
      <div class="tr">
        <div class="th">教師性別</div>
        <div class="td">男性限定OK・女性限定OK・性別指定不可</div>
      </div>
      <div class="tr">
        <div class="th">交通費</div>
        <div class="td">送迎が付く場合 ~  __________円・送迎が付かない場合 ~ __________円</div>
      </div>
      <div class="tr">
        <div class="th">探し期間</div>
        <div class="td">2週間・3週間・4週間</div>
      </div>
      <div class="tr">
        <div class="th">その他</div>
        <div class="td">長期決まるまで短期派遣の可能性有り</div>
      </div>
      <div class="tr">
        <div class="td">教師数が少ないので条件内の紹介が出来ない可能性有り</div>
      </div>
      <div class="tr">
        <div class="td">週2希望の場合は先生2人体制・連日指導の可能性有り</div>
      </div>
      <div class="tr">
        <div class="td">全条件(年齢・曜日・時間帯)広くないと紹介不可</div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  // 直前のstore使ってるだけなので注意
  computed: {
    user () {
      return this.$store.getters.user
    },

    appointment () {
      return this.$store.getters.appointment
    }
  }
}
</script>

<style lang="scss" scoped>
.user-icon {
  display: none !important;
}
.wrapper {
  display: flex;
  // flex-flow: column;
  width: 700px;
  // height: 950px;
  border-top: solid 1px #ccc;
}
.title {
  max-width: 690px;
  margin: 5px;
  span {
    font-size: 14px;
    font-weight: normal;
  }
}
.table {
  display: flex;
  flex-flow: column wrap;
  .tr {
    width: 350px;
    border-top: none;
    border-bottom: solid 1px #ccc;
    border-right: solid 1px #ccc;
    border-left: solid 1px #ccc;
    display: flex;
    .th {
      width: 135px;
      background: #f4f4f4;
      color: #333;
      padding: 5px;
    }
    .td {
      width: 213px;
      padding: 5px;
      word-wrap: break-word;
    }
  }
}
.note {
  .tr {
    width: 700px;
    .th {
      width: 700px;
      border-top: solid 1px #ccc;
      /* border-bottom: solid 1px #ccc; */
      border-right: solid 1px #ccc;
      border-left: solid 1px #ccc;
      background: #f4f4f4;
      color: #333;
      padding: 5px;
    }
    .td {
      border-top: solid 1px #ccc;
      border-bottom: solid 1px #ccc;
      border-right: solid 1px #ccc;
      border-left: solid 1px #ccc;
      padding: 5px;
      word-break: break-word;
      width: 700px;
      min-height: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PrintAp.vue?2136f6f8